import moment from "moment";
import React from "react";
import {
  getWeekColumnData,
  isCurrentWeek,
} from "../../../../../utils/annual-planner-helpers";

export const PhasesDescriptionBubbles = ({
  numberOfWeeks,
  month,
  startingCalendarDay,
  exactWeek,
  phasesDescriptions,
  onSelectWeek,
}) => {
  return (
    //   This is the row containing the description bubbles
    <div className="phases-descriptions-wrapper">
      {Array.from(Array(numberOfWeeks).keys(), (weekNumber) => {
        const weekFirstDay = getWeekColumnData(
          month,
          startingCalendarDay,
          weekNumber
        );
        // We show one per week
        return (
          <div
            key={weekFirstDay.format("YYYYMMDD")}
            className={`description-bubble-slot${isCurrentWeek(weekFirstDay) ? " current-week" : ""}`}
          >
            <DescriptionBubble
              weekFirstDay={weekFirstDay}
              exactWeek={exactWeek}
              phasesDescriptions={phasesDescriptions}
              onSelectWeek={onSelectWeek}
            />
          </div>
        );
      })}
    </div>
  );
};

const DescriptionBubble = ({
  weekFirstDay,
  phasesDescriptions,
  onSelectWeek,
}) => {
  // Getting the last day of the week to handle the range between which the phase description could exist
  const weekLastDay = moment(weekFirstDay).add(6, "days");

  // We get the current description object corresponding to the current week (if exists)
  const phaseDescriptionObject = phasesDescriptions?.find((description) =>
    moment(description.dateAttachment, "YYYYMMDD").isBetween(
      moment(weekFirstDay),
      moment(weekLastDay),
      undefined,
      "[]"
    )
  );

  return (
    <div //NOSONAR
      className="phase-description-bubble"
      onClick={() => onSelectWeek(weekFirstDay)}
    >
      {phaseDescriptionObject ? (
        <img src="/img/new-icons/check-gradient.svg" alt="Checkmark" />
      ) : (
        <img
          className="add-note-icon"
          src="/img/new-icons/add.svg"
          alt="Add Note"
        />
      )}
    </div>
  );
};
